<div class="search-container d-inline-block float-lg-none">
  <a
    #triggerElement
    (click)="!avoidFocus ? open() : null"
    [attr.tabindex]="avoidFocus ? -1 : 0"
    aria-haspopup="true"
    class="search icon-search-icon circle-outline"
    (keydown)="handleFocusEvent($event)"
    href="javascript:void(0);"
    aria-label="search-button"
    id="search-button"
  >
    <img
      alt="Search"
      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    />
  </a>
</div>
